// import hooks
import { useState } from "react";
import { isNavigationRailTierOneSelected } from "../../NavigationRail.utils.js";
export const useNavigationRailItem = ({ id, label, submenu, onClick, onItemClick, onMouseOver, isLoading, selectedId, tabIndex = 0, }) => {
    const [isFirstTouch, setIsFirstTouch] = useState(true);
    const selected = id === selectedId || submenu?.some((item) => isNavigationRailTierOneSelected(item, selectedId));
    return {
        selected,
        listItemButtonProps: {
            onClick: (e) => {
                if (isLoading)
                    return;
                const pointerType = e.nativeEvent instanceof PointerEvent ? e.nativeEvent.pointerType : "mouse";
                if (pointerType === "touch" && isFirstTouch) {
                    setIsFirstTouch(false);
                }
                else {
                    setIsFirstTouch(true);
                    onClick?.();
                }
                if (pointerType === "mouse") {
                    onClick?.();
                }
                onItemClick?.({ id, label, submenu });
            },
            disablePadding: true,
            disableRipple: true,
            disableTouchRipple: true,
            alignItems: "center",
            component: "div",
            tabIndex,
            selected,
        },
        onMouseEnter: () => onMouseOver?.({ id, label, submenu }),
    };
};
export default useNavigationRailItem;
